import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HOW_IT_WORKS_IDS, PAYMENT_THRESHOLD } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import Breadcrumb from '../../breadcrumb/Breadcrumb';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import CustomerServiceComponent from '../../CustomerServiceComponent';

import './HowItWorksPage.scss';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

export class HowItWorksPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    render() {
        const { i18nPage, BRAND_NAME_ALT, BRAND_NAME_ALT_2, COMPANY_NAME, faqData } = this.props;

        // Currently select the first theme with non empty faq list /!\
        let faqs = [];
        faqData.map(theme => theme.faqs && theme.faqs.map(faq => faqs.push(faq)));
        const filteredFaqs = faqs.filter(f => HOW_IT_WORKS_IDS.includes(f.id));

        return (
            <React.Fragment>
                <main role="main" className="conteneur conteneur-mobile" id="p-cmt-ca-marche">
                    <HeadComponent
                        title={i18nPage.TITLE}
                        description={i18nPage.DESCRIPTION}
                        canonicalLink={`${CONTEXT_ROOT}${PATH.HOW_IT_WORK_PATH}`}
                    />
                    <Breadcrumb
                        defaultRoute
                        routes={[
                            {
                                label: i18nPage.BREADCRUMB,
                                route: PATH.HOW_IT_WORK_PATH
                            }
                        ]}
                    />

                    <h1>{i18nPage.H1}</h1>

                    <div className="ccm-text">
                        <h3>{convertHtmlToReactDomWithParams(i18nPage.H31, BRAND_NAME_ALT)}</h3>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18nPage.TEXT1_1,
                                COMPANY_NAME,
                                BRAND_NAME_ALT_2
                            )}
                        </p>
                        <ul>
                            <li>{i18nPage.TEXT1_2}</li>
                            <li>{i18nPage.TEXT1_3}</li>
                        </ul>
                        <p>{convertHtmlToReactDomWithParams(i18nPage.TEXT1_4, BRAND_NAME_ALT_2)}</p>

                        <h3>{i18nPage.H32}</h3>
                        <p>{i18nPage.TEXT_2_1}</p>

                        <h3>{convertHtmlToReactDomWithParams(i18nPage.H33, BRAND_NAME_ALT_2)}</h3>
                        <p>{i18nPage.TEXT3_1}</p>
                        <p>{i18nPage.TEXT3_2}</p>
                        <p>{i18nPage.TEXT3_3}</p>

                        <h3>{i18nPage.H34}</h3>
                        <p>
                            {convertHtmlToReactDomWithParams(i18nPage.TEXT_4_1, PAYMENT_THRESHOLD)}
                        </p>
                    </div>

                    <hr />

                    <HowItWorksComponent showButtons />

                    <hr />

                    <div className="help-container grid">
                        <div className="faq-container inbl">
                            <div className="faq-bandeau">
                                <h2>{i18nPage.QUESTION}</h2>
                                <LinkButtonComponent
                                    to={PATH.FAQ_PATH}
                                    title={i18nPage.FREQUENTLY_ASKED_QUESTIONS}
                                    color="main"
                                    text={i18nPage.FREQUENTLY_ASKED_QUESTIONS}
                                />
                            </div>
                            <div className="faq-list-container">
                                {filteredFaqs.map(faq => (
                                    <FaqElementComponent
                                        key={faq.id}
                                        faq={faq}
                                        cssClass="question-comment-ca-marche-page"
                                    />
                                ))}
                            </div>
                        </div>

                        <CustomerServiceComponent />
                    </div>
                </main>
            </React.Fragment>
        );
    }
}

HowItWorksPage.propTypes = {
    i18nPage: PropTypes.object.isRequired,
    faqData: PropTypes.array
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.HOW_IT_WORKS,
        BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT,
        BRAND_NAME_ALT_2: state.i18n.common.BRAND_NAME_ALT_2,
        COMPANY_NAME: state.i18n.common.COMPANY_NAME,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPage.js